'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagEuAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 8.88109e-06C9.33333 -8.36891e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20L0 8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 8.88109e-06L28 0V20H0L0 8.88109e-06Z", fill: "#043CAE" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.0572 4.27614L14 4L14.9428 4.27614L14.6667 3.33333L14.9428 2.39052L14 2.66667L13.0572 2.39052L13.3333 3.33333L13.0572 4.27614Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.0572 17.6095L14 17.3333L14.9428 17.6095L14.6667 16.6667L14.9428 15.7239L14 16L13.0572 15.7239L13.3333 16.6667L13.0572 17.6095Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.6667 10.6667L19.7239 10.9428L20 10L19.7239 9.05719L20.6667 9.33333L21.6095 9.05719L21.3333 10L21.6095 10.9428L20.6667 10.6667Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.39052 10.9428L7.33333 10.6667L8.27614 10.9428L8 10L8.27614 9.05719L7.33333 9.33333L6.39052 9.05719L6.66667 10L6.39052 10.9428Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.7735 7.33333L18.8307 7.60948L19.1068 6.66667L18.8307 5.72386L19.7735 6L20.7163 5.72386L20.4402 6.66667L20.7163 7.60948L19.7735 7.33333Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.28369 14.2761L8.2265 14L9.16931 14.2761L8.89316 13.3333L9.16931 12.3905L8.2265 12.6667L7.28369 12.3905L7.55983 13.3333L7.28369 14.2761Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3333 4.89316L16.3905 5.16931L16.6667 4.2265L16.3905 3.28369L17.3333 3.55983L18.2761 3.28369L18 4.2265L18.2761 5.16931L17.3333 4.89316Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.72386 16.7163L10.6667 16.4402L11.6095 16.7163L11.3333 15.7735L11.6095 14.8307L10.6667 15.1068L9.72386 14.8307L10 15.7735L9.72386 16.7163Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.7735 14L18.8307 14.2761L19.1068 13.3333L18.8307 12.3905L19.7735 12.6667L20.7163 12.3905L20.4402 13.3333L20.7163 14.2761L19.7735 14Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.28369 7.60948L8.2265 7.33333L9.16931 7.60948L8.89316 6.66667L9.16931 5.72386L8.2265 6L7.28369 5.72386L7.55983 6.66667L7.28369 7.60948Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3333 16.4402L16.3905 16.7163L16.6667 15.7735L16.3905 14.8307L17.3333 15.1068L18.2761 14.8307L18 15.7735L18.2761 16.7163L17.3333 16.4402Z",
          fill: "#FFD429"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.72386 5.16931L10.6667 4.89316L11.6095 5.16931L11.3333 4.2265L11.6095 3.28369L10.6667 3.55983L9.72386 3.28369L10 4.2265L9.72386 5.16931Z",
          fill: "#FFD429"
        }
      )
    ]
  }
);
const VpFlagEuAsset = forwardRef(FlagEuAsset);

export { VpFlagEuAsset as default };
